<template>
    <div :class="'bizcomp-wx-unbind bizcomp ' + className">
        <el-row class="wx-unbind-container">
            <el-col :span="24" style="padding: 0">
                <el-tabs v-model="activeName" v-on:tab-click="handleTabClick">
                    <!-- Tab 1: 已有账号，请绑定 -->
                    <el-tab-pane name="first">
                        <span slot="label">
                            <i class="icon-account"></i>
                            <span>已在{{ companyName }}公司开户，请绑定</span>
                        </span>
                        <!-- 提示框 -->
                        <div class="user-img">
                            <img src="@/assets/img/loginPage/user-icon.png" />
                            <span class="text">
                                您好，欢迎来到{{ companyName }}，完成绑定后可以微信账号一键登录哦~
                            </span>
                        </div>

                        <el-form
                            ref="loginForm"
                            :rules="rules"
                            :model="loginForm"
                            label-width="0"
                            class="bind-form"
                            v-on:keyup.enter.native="bindAccount"
                        >
                            <!-- 证件类型选择 -->
                            <el-form-item label="" prop="certType" class="icon-select">
                                <i class="fa fa-id-card select-card" aria-hidden="true" />
                                <el-select
                                    v-model="loginForm.certType"
                                    placeholder="身份证/手机号"
                                    v-on:change="checkCertNoAgain"
                                >
                                    <el-option
                                        v-for="item in certTypes"
                                        :key="item.subitem"
                                        :label="item.subitemname"
                                        :value="item.subitem"
                                    />
                                </el-select>
                            </el-form-item>

                            <!-- 证件号/手机号 -->
                            <el-form-item label="" prop="certNo">
                                <el-input
                                    v-model.trim="loginForm.certNo"
                                    :maxlength="20"
                                    :placeholder="certNoPlaceholder"
                                    prefix-icon="fa el-icon-user-solid"
                                />
                            </el-form-item>

                            <!-- 密码 -->
                            <el-form-item label="" prop="password" class="password-item">
                                <el-input
                                    v-model.trim="loginForm.password"
                                    type="password"
                                    class="reset-pwd"
                                    :maxlength="32"
                                    placeholder="请输入密码"
                                    prefix-icon="fa fa-lock"
                                    v-on:keydown.native="detectCapsLock"
                                ></el-input>
                                <div class="capsLock-tip js-capsLock" :class="{ hide: !capsLock }">
                                    <i class="capsLockTip-triangle" aria-hidden="true" />
                                    大写锁定已打开
                                </div>
                            </el-form-item>

                            <!-- 忘记密码链接 -->
                            <div class="forget-pwd-wrapper">
                                <span class="forget-pwd-link" v-on:click="forgetPwd">忘记密码</span>
                            </div>

                            <!-- 按钮组 -->
                            <div class="button-group">
                                <el-button type="primary" class="bind-btn" v-on:click="bindAccount">
                                    立即绑定
                                </el-button>
                                <el-button class="back-btn" v-on:click="goBack">返回</el-button>
                            </div>
                        </el-form>
                    </el-tab-pane>

                    <!-- Tab 2: 没有账号，请完善资料 -->
                    <el-tab-pane name="second">
                        <span slot="label">
                            <i class="icon-register"></i>
                            <span>未在{{ companyName }}公司开户，请完善资料</span>
                        </span>
                    </el-tab-pane>
                </el-tabs>
            </el-col>
        </el-row>

        <!-- 双因素短信验证弹窗 -->
        <smsValid
            :dialog-visible="smsVisible"
            sms-type="1"
            :mobileno="mobileno"
            :en-mobileno="en_mobileno"
            :certificateno="loginForm.certNo"
            :show-remote="showRemote"
            :biz-type="$const.IMG_BIZTYPE.TWOFACTORAUTH"
            v-on:sms-comfirm="onSmsConfirm"
            v-on:close="smsVisible = false"
        />
    </div>
</template>

<script>
import mixin from "@/assets/js/mixin";
import smsValid from "@/components/form/smsValid.vue";
import userApi from "@/api/user";
import { clearUrlQuery } from "@/util/url.js";

export default {
    name: "WxUnbind",
    components: {
        smsValid
    },
    mixins: [mixin],
    data() {
        return {
            className: "",
            companyName: "",
            titTips: {
                tit: "微信账号绑定",
                text: "绑定后可使用微信快捷登录",
                cla: "register"
            },
            activeName: "first",
            loginCertType: "2",
            certTypes: [],
            capsLock: false,
            showImgCode: false,
            imgSrc: "",
            loginForm: {
                password: "",
                verifyCode: "",
                certType: "00",
                certNo: ""
            },
            rules: {
                certType: [
                    {
                        required: true,
                        message: "请选择证件类型",
                        trigger: "change"
                    }
                ],
                certNo: [{ validator: this.checkCertNo, trigger: "change" }],
                password: [{ required: true, message: "请输入密码", trigger: "blur" }],
                verifyCode: [
                    {
                        validator: this.$util.validateImgVerifyCode,
                        trigger: "blur"
                    }
                ]
            },
            // 双因素相关
            smsVisible: false,
            mobileno: "",
            en_mobileno: "",
            showRemote: false,
            twoFactorBindData: null // 缓存首次 login 返回的数据，等短信验证通过后使用
        };
    },
    computed: {
        certNoPlaceholder() {
            const selectedType = this.certTypes.find(
                (item) => item.subitem === this.loginForm.certType
            );
            if (selectedType) {
                return `请输入${selectedType.subitemname}`;
            }
            return "请输入证件号码";
        }
    },
    mounted() {
        // 获取公司名称参数
        this.companyName = this.$cache.getCompanyInfoParam("10101014") || "";

        this.certTypes = (this.$cache.getDict("130007") &&
            JSON.parse(JSON.stringify(this.$cache.getDict("130007")))) || [
            {
                dictitem: "130007",
                itemorder: 0,
                itemtype: null,
                subitem: "00",
                subitemname: "身份证",
                sysid: 100
            }
        ];
        this.certTypes = this.certTypes.concat([
            {
                dictitem: "130007",
                subitem: "000",
                subitemname: "基金账号",
                sysid: "4"
            }
        ]);
        // 将证件类型 "00" 改为"身份证/手机号"
        let findIndex = this.certTypes.findIndex((item) => item.subitem === `00`);
        if (findIndex >= 0) {
            this.certTypes[findIndex].subitemname = `身份证/手机号`;
        }
        this.refresh();
    },
    methods: {
        handleTabClick(tab) {
            if (tab.name === "second") {
                this.activeName = "first";
                const query = {};
                if (this.$route.query.code) {
                    query.code = this.$route.query.code;
                }
                if (this.$route.query.logintoken) {
                    query.logintoken = this.$route.query.logintoken;
                }
                this.$router.push({ name: "bindnewacct", query });
            }
        },
        checkCertNo(rule, value, callback) {
            const selectedType = this.certTypes.find(
                (item) => item.subitem === this.loginForm.certType
            );
            const typeName = selectedType ? selectedType.subitemname : "证件号码";

            if (value === "") {
                callback(new Error(`请输入${typeName}`));
                return;
            }
            if (this.loginForm.certType === `00` && value.length === 11) {
                // 身份证号/手机号混合登录，11位时判断是否为手机号
                const regex = /^1[3-9]\d{9}$/;
                if (regex.test(value)) {
                    callback();
                } else {
                    callback(new Error(`请输入正确格式的手机号`));
                }
                return;
            }
            // 基金账号类型时，不调用 validateCertNo，直接通过
            if (this.loginForm.certType === "000") {
                callback();
                return;
            }
            this.$util.validateCertNo(rule, value, callback, this.loginForm.certType);
        },
        checkCertNoAgain() {
            // 切换证件类型时清空输入框
            this.loginForm.certNo = "";
            this.$refs.loginForm.validateField("certNo");
        },
        detectCapsLock() {
            this.capsLock = this.$util.detectCapsLock();
        },
        refresh() {
            this.$util.imgUrl().then((res) => {
                this.imgSrc = res.data.image;
            });
        },
        bindAccount() {
            this.$refs.loginForm.validate((valid) => {
                if (valid) {
                    this.performBind();
                } else {
                    this.$errorScroll();
                }
            });
        },
        // 双因素短信验证通过回调
        onSmsConfirm() {
            const { data, accttype } = this.twoFactorBindData || {};
            if (!data) {
                this.$message.error("登录状态失效，请重新登录");
                return;
            }
            this.twoFactorBindData = null;
            this.smsVisible = false;
            this.finishBind(data, accttype);
        },
        async performBind() {
            try {
                const loginPwd = this.$util.enc(this.loginForm.password);

                // 将 URL 中的 logintoken 写入 session，供 http.js 拦截器自动带入请求
                const logintoken = this.$route.query.logintoken || "";
                const session = JSON.parse(sessionStorage.getItem("_a") || "{}");
                session.token = logintoken;
                sessionStorage.setItem("_a", JSON.stringify(session));

                let accttype = this.loginForm.certType === "000" ? "2" : "0";

                let _data = {
                    accttype,
                    logintype: "05",
                    certificatetype:
                        this.loginForm.certType === "000" ? "" : this.loginForm.certType,
                    certificateno: this.loginForm.certNo,
                    verifycode: this.loginForm.verifyCode,
                    pwd: loginPwd,
                    oauthbindflag: "1",
                    // 微信未绑定后的账号绑定登录仍按个人网交处理，避免经办人个人户/机构户歧义。
                    invtp: "1"
                };

                // 手机号自动识别：certType 为 "00" 且输入内容为手机号时，按手机号登录入参处理
                const phoneRegex = /^1[3-9]\d{9}$/;
                if (this.loginForm.certType === "00" && phoneRegex.test(this.loginForm.certNo)) {
                    _data = {
                        ..._data,
                        logintype: "05",
                        certificatetype: "",
                        certificateno: "",
                        accttype: "8",
                        mobileno: this.loginForm.certNo
                    };
                }

                const res = await userApi.login(_data);

                if (res.error) {
                    return;
                }

                const { data } = res;

                // ==========================
                // 双因素判断
                // ==========================
                const twoFlag = data && data.others && data.others.twofactorauthflag;
                if (["1", "2", "3"].includes(String(twoFlag))) {
                    this.twoFactorBindData = { data, accttype: _data.accttype };
                    this.mobileno = data.others.mobileno;
                    this.en_mobileno = data.others.en_mobileno;
                    this.showRemote = twoFlag === "2";
                    this.smsVisible = true;
                    return;
                }

                // ==========================
                // 无需双因素，直接完成绑定
                // ==========================
                this.finishBind(data, _data.accttype);
            } catch (e) {
                console.error("bind error:", e);
                this.refresh();
            }
        },
        // 绑定完成后统一处理
        finishBind(data, accttype) {
            this.$cache.setBinded(data.others.isbind === "1");
            this.$cache.setHeadImage(data.others.headimage || "");
            data.others.accttype = accttype;
            this.$cache.setUserOtherInfo(data.others);

            this.$store
                .dispatch("login", {
                    key: this.loginForm.certNo,
                    ...JSON.parse(sessionStorage.getItem("_a") || "{}"),
                    userinfo: data.others,
                    userName: data.userName
                })
                .then(() => {
                    this.$message.success("绑定成功");
                    this.$router.push("/home");
                });
        },
        forgetPwd() {
            this.$router.push({ name: "retrievepwd", query: { tit: "找回密码" } });
        },
        goBack() {
            clearUrlQuery("code");
            this.$router.push({ name: "login" });
        }
    }
};
</script>

<style lang="scss">
.bizcomp-wx-unbind {
    border: 1px solid var(--color-border-base);

    .wx-unbind-container {
        padding-left: 0;
        padding-right: 0;
        max-width: 1200px;
        margin: 0 auto;

        .el-tabs {
            .el-tabs__nav-scroll {
                margin: 0 auto;
                width: 100%;
                text-align: center;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .el-tabs__header {
                padding: 0 20px;
            }

            .el-tabs__nav-wrap {
                display: flex;
                justify-content: center;
            }

            .el-tabs__nav {
                display: flex;
                justify-content: center;
                width: auto;
            }

            .el-tabs__item {
                width: auto;
                font-size: 16px;
                color: var(--color-text-regular);
                flex: 0;
                text-align: center;
                padding: 0 150px;
                border-bottom: 3px solid transparent;
                position: relative;
                height: 60px;
                line-height: 60px;
                margin: 0;

                &.is-active {
                    color: var(--color-primary);
                    border-bottom-color: var(--color-primary);
                }

                i {
                    margin-right: 8px;
                    font-size: 16px;
                }
            }
        }

        .el-tabs__active-bar {
            display: none;
        }

        .el-tabs__content {
            padding: 0 120px 20px 120px;
        }

        // 提示框样式
        .user-img {
            padding: 15px 20px;
            width: 100%;
            max-width: 640px;
            height: auto;
            line-height: 1.5;
            color: var(--color-button-press);
            border: 1px solid var(--color-accent);
            background-color: var(--color-secondary);
            border-radius: 4px;
            margin: 20px auto;
            display: flex;
            align-items: center;
            gap: 12px;

            img {
                display: inline-block;
                width: 24px;
                height: 24px;
                flex-shrink: 0;
                object-fit: contain;
            }

            .text {
                font-size: 14px;
                color: var(--color-button-press);
            }
        }

        // 表单样式
        .bind-form {
            max-width: 340px;
            margin: 30px auto 0;

            .el-form-item {
                margin-bottom: 20px;

                &.is-required .el-form-item__label:before {
                    content: "";
                }

                &.icon-select {
                    position: relative;

                    .select-card {
                        position: absolute;
                        left: 12px;
                        top: 50%;
                        transform: translateY(-50%);
                        z-index: 1000;
                        font-size: 16px;
                        color: var(--color-text-accent);
                    }

                    .el-select {
                        width: 100%;

                        .el-input__inner {
                            padding-left: 40px;
                            border: 1px solid var(--color-border-base);
                            border-radius: 4px;
                            height: 40px;
                            line-height: 40px;
                            font-size: 14px;
                        }
                    }
                }

                &.password-item {
                    position: relative;
                    margin-bottom: 12px;
                }

                .el-input {
                    .el-input__inner {
                        border: 1px solid var(--color-border-base);
                        border-radius: 4px;
                        padding-left: 40px;
                        height: 40px;
                        line-height: 40px;
                        font-size: 14px;
                    }

                    .el-input__icon {
                        font-size: 16px;
                        color: var(--color-text-accent);
                    }
                }

                .el-select {
                    width: 100%;
                }

                .el-form-item__error {
                    position: absolute;
                    top: 100%;
                    left: 0;
                    font-size: 12px;
                    color: var(--color-danger);
                    line-height: 1;
                    padding-top: 4px;
                }
            }

            .capsLock-tip {
                position: relative;
                width: 100%;
                font-size: 12px;
                color: var(--color-danger);
                padding: 4px 0;
                margin-top: 4px;
                display: flex;
                align-items: center;

                &.hide {
                    display: none;
                }

                .capsLockTip-triangle {
                    margin-right: 4px;
                }
            }

            .button-group {
                display: flex;
                gap: 16px;
                margin-top: 30px;

                .bind-btn {
                    flex: 1;
                    height: 40px;
                    font-size: 14px;
                    background-color: var(--color-primary);
                    border-color: var(--color-primary);
                    color: var(--color-text-white);

                    &:hover {
                        background-color: var(--button-bg-press);
                        border-color: var(--button-bg-press);
                    }
                }

                .back-btn {
                    flex: 1;
                    height: 40px;
                    font-size: 14px;
                    background-color: var(--color-bg-container);
                    border-color: var(--color-border-base);
                    color: var(--color-text-regular);

                    &:hover {
                        background-color: var(--bg-color-lightest);
                        border-color: var(--color-border-base);
                    }
                }
            }

            .forget-pwd-wrapper {
                text-align: right;
                margin-bottom: 20px;

                .forget-pwd-link {
                    color: var(--color-redirect);
                    cursor: pointer;
                    font-size: 12px;
                    text-decoration: none;

                    &:hover {
                        text-decoration: underline;
                    }
                }
            }
        }
    }
}
</style>
